/* =======================================================
   GROOMLY — theme JavaScript
   Cart drawer (AJAX), quick add, variant picker, gallery,
   tabs, scroll rows, mobile nav, filters, sort, wishlist,
   predictive search, recommendations.
======================================================= */
(function () {
  'use strict';

  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };

  /* ── Money formatting ─────────────────────────────── */
  function formatMoney(cents) {
    var format = (window.Groomly && window.Groomly.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withCommas);
  }

  /* ── Cart drawer ──────────────────────────────────── */
  function drawerEl() { return $('[data-cart-drawer]'); }

  function openCart() {
    var d = drawerEl();
    if (d) { d.classList.add('open'); document.body.style.overflow = 'hidden'; }
  }
  function closeCart() {
    var d = drawerEl();
    if (d) { d.classList.remove('open'); document.body.style.overflow = ''; }
  }

  function updateCartBadges(count) {
    $$('[data-cart-count]').forEach(function (badge) {
      badge.textContent = count > 9 ? '9+' : String(count);
      badge.hidden = count === 0;
    });
  }

  function refreshCartDrawer(openAfter) {
    var d = drawerEl();
    if (d) d.classList.add('loading');
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (html && d) {
          var wasOpen = d.classList.contains('open');
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var fresh = temp.querySelector('[data-cart-drawer]');
          if (fresh) {
            // Swap the contents without a visible rebuild: keep the product images that are already loaded,
            // the list's scroll position and anything typed in the order note.
            var oldBody = d.querySelector('.cart-drawer-body'), scroll = oldBody ? oldBody.scrollTop : 0;
            var oldNote = d.querySelector('[data-cart-note]'), typed = oldNote ? oldNote.value : null;
            var noteFocused = oldNote && document.activeElement === oldNote;
            var images = {};
            $$('img', d).forEach(function (img) { var src = img.getAttribute('src'); if (src) images[src] = img; });
            $$('img', fresh).forEach(function (img) { var keep = images[img.getAttribute('src')]; if (keep) img.parentNode.replaceChild(keep, img); });
            // Keep the sliding panel and its backdrop themselves (a new panel would cut its slide-in short and
            // jump); only what is inside the panel is replaced.
            var oldSheet = d.querySelector('.cart-drawer-sheet'), newSheet = fresh.querySelector('.cart-drawer-sheet');
            if (oldSheet && newSheet) {
              while (oldSheet.firstChild) oldSheet.removeChild(oldSheet.firstChild);
              while (newSheet.firstChild) oldSheet.appendChild(newSheet.firstChild);
            } else {
              d.innerHTML = '';
              while (fresh.firstChild) d.appendChild(fresh.firstChild);
            }
            var newBody = d.querySelector('.cart-drawer-body'); if (newBody) newBody.scrollTop = scroll;
            // Quantities tapped while this refresh was on its way keep showing (they are saved next).
            Object.keys(cartQueue.pending).forEach(function (variant) {
              $$('[data-variant]', d).forEach(function (btn) {
                if (btn.getAttribute('data-variant') !== variant) return;
                var it = btn.closest('.cart-item'), n = it && it.querySelector('.qty-num');
                if (n) n.textContent = String(cartQueue.pending[variant]);
                if (it && cartQueue.pending[variant] === 0) it.classList.add('is-removing');
              });
            });
            var newNote = d.querySelector('[data-cart-note]');
            if (newNote && typed !== null) { newNote.value = typed; if (noteFocused) newNote.focus(); }
            if (wasOpen || openAfter) d.classList.add('open');
          }
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartBadges(cart.item_count);
        if (d) d.classList.remove('loading');
        if (openAfter) openCart();
      })
      .catch(function () { if (d) d.classList.remove('loading'); });
  }

  // Back from checkout the browser shows the page as it was left: bring the bag and its count up to date.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCartDrawer(false); });

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error(err.description || err.message || 'Could not add to bag');
        });
      }
      return res.json();
    });
  }

  function changeLine(line, quantity, reload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(function (res) { return res.json(); })
      .then(function () {
        if (reload) { window.location.reload(); } else { refreshCartDrawer(false); }
      });
  }

  // Bag changes made in the drawer go through a queue, one entry per product variant: a tap while the bag is
  // still saving is never lost (it is applied right after), quick repeated taps add up, and nothing depends on
  // row numbers that move when an item is removed. An item's cart key changes whenever its quantity changes
  // (the discount is part of it), so each save uses the key from Shopify's last answer. The drawer refreshes
  // once the queue is empty.
  var cartQueue = { pending: {}, keys: {}, busy: false };
  function queueLine(variant, key, quantity) {
    if (!cartQueue.busy) cartQueue.keys = {};
    if (!cartQueue.keys[variant]) cartQueue.keys[variant] = key;
    cartQueue.pending[variant] = quantity;
    var d = drawerEl(); if (d) d.classList.add('loading');
    if (!cartQueue.busy) runQueue();
  }
  function runQueue() {
    var keys = Object.keys(cartQueue.pending);
    if (!keys.length) {
      return refreshCartDrawer(false).then(function () {
        cartQueue.busy = false;
        if (Object.keys(cartQueue.pending).length) { cartQueue.busy = true; runQueue(); }
      });
    }
    cartQueue.busy = true;
    var dr = drawerEl(); if (dr) dr.classList.add('loading');
    var variant = keys[0], quantity = cartQueue.pending[variant];
    delete cartQueue.pending[variant];
    var remember = function (cart) { if (cart && cart.items) cart.items.forEach(function (it) { cartQueue.keys[String(it.variant_id)] = it.key; }); };
    var send = function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: cartQueue.keys[variant], quantity: Math.max(0, quantity) })
      }).then(function (res) { return res.ok ? res.json() : null; });
    };
    return send().then(function (cart) {
      if (cart) { remember(cart); return; }
      // The key was already out of date (e.g. right after adding, while the discount is worked out): take the
      // item's current key from the bag and try once more.
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (now) {
        remember(now);
        if (now.items.some(function (it) { return String(it.variant_id) === variant; })) return send().then(remember);
      });
    }).catch(function () {}).then(runQueue);
  }

  /* ── Wishlist (localStorage) ──────────────────────── */
  var WISHLIST_KEY = 'groomly:wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }
  function setWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    syncWishlistUI();
  }
  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) list.push(handle); else list.splice(idx, 1);
    setWishlist(list);
  }
  function syncWishlistUI() {
    var list = getWishlist();
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    $$('[data-wishlist-count]').forEach(function (badge) {
      badge.textContent = list.length > 9 ? '9+' : String(list.length);
      badge.hidden = list.length === 0;
    });
  }

  function renderWishlistPage() {
    var grid = $('[data-wishlist-grid]');
    if (!grid) return;
    var empty = $('[data-wishlist-empty]');
    var list = getWishlist();
    if (list.length === 0) {
      if (empty) empty.hidden = false;
      return;
    }
    Promise.all(list.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var items = products.filter(Boolean);
      if (items.length === 0 && empty) { empty.hidden = false; return; }
      grid.innerHTML = items.map(function (p) { return cardHTML(p, false); }).join('');
      syncWishlistUI();
    });
  }

  /* ── Product card markup for client-rendered rows (wishlist, recently viewed) ── */
  var HEART_SVG = '<svg class="icon icon-heart" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19.5 12.6 12 20l-7.5-7.4A4.6 4.6 0 0 1 12 6.6a4.6 4.6 0 0 1 7.5 6Z"/></svg>';
  var BAG_SVG = '<svg class="icon icon-bag" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l1.2 13H4.8L6 7Z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg>';

  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardHTML(p, scroll) {
    var onSale = p.compare_at_price > p.price;
    var cl = (window.Groomly && window.Groomly.clearance) || {};
    var clearanceTag = String(cl.tag || 'clearance').toLowerCase();
    var isClearance = cl.enabled !== false && (p.tags || []).some(function (t) { return String(t).trim().toLowerCase() === clearanceTag; });
    var clPos = cl.position || 'top_left';
    var clBadge = '<span class="product-badge clearance">' + escapeHTML(cl.label || 'Clearance') + '</span>';
    var badge = '<div class="product-badges">' + (!p.available ? '<span class="product-badge">Sold out</span>'
      : (isClearance && clPos === 'top_left' ? clBadge : '') +
        (onSale ? '<span class="product-badge sale">−' + Math.floor((p.compare_at_price - p.price) * 100 / p.compare_at_price) + '%</span>' : '')) + '</div>' +
      (isClearance && p.available && clPos !== 'top_left' ? '<div class="product-badges product-badges--' + clPos.replace('_', '-') + '">' + clBadge + '</div>' : '');
    var img = p.featured_image
      ? '<img class="product-card-img" src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="' + escapeHTML(p.title) + '" loading="lazy" width="400" height="400">'
      : '';
    var quick = !p.available ? '<span class="product-quick-add is-muted">Sold out</span>'
      : p.variants.length === 1
        ? '<button type="button" class="product-quick-add" data-quick-add data-variant-id="' + p.variants[0].id + '" aria-label="Add ' + escapeHTML(p.title) + ' to bag">' + BAG_SVG + '<span data-quick-label>Add to bag</span></button>'
        : '<span class="product-quick-add">Choose options</span>';
    return '<a href="' + p.url + '" class="product-card' + (scroll ? ' product-card--scroll' : '') + '">' +
      '<div class="product-img-wrap' + (img ? '' : ' product-img-wrap--empty') + '">' + badge + img +
      '<button class="product-wishlist" type="button" data-wishlist-toggle data-handle="' + escapeHTML(p.handle) + '" aria-label="Save ' + escapeHTML(p.title) + ' to wishlist" aria-pressed="false">' + HEART_SVG + '</button>' +
      '</div><div class="product-body">' +
      (p.vendor ? '<div class="product-brand">' + escapeHTML(p.vendor) + '</div>' : '') +
      '<div class="product-name">' + escapeHTML(p.title) + '</div>' +
      '<div class="product-price-row"><span class="product-price' + (onSale ? ' is-sale' : '') + '">' + formatMoney(p.price) + '</span>' +
      (onSale ? '<s class="product-compare">' + formatMoney(p.compare_at_price) + '</s>' : '') +
      '</div></div>' + quick + '</a>';
  }

  /* ── Product page ─────────────────────────────────── */
  function initProductPage() {
    var page = $('[data-product-page]');
    var jsonEl = $('[data-product-json]');
    if (!page || !jsonEl) return;

    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var qtyInput = $('[data-qty-input]', page);
    var form = $('[data-product-form]', page) || document.getElementById('ProductForm');

    /* Gallery: native scroll-snap slider, dots + thumbs follow the visible slide */
    var slider = $('[data-slider]', page);
    var dots = $$('[data-dot]', page);
    var thumbs = $$('[data-goto]', page);
    function goToSlide(index, smooth) {
      if (!slider) return;
      var slide = slider.children[index];
      if (slide) slider.scrollTo({ left: slide.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function markActive(index) {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }
    if (slider && slider.children.length > 1) {
      var ticking = false;
      slider.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          markActive(Math.round(slider.scrollLeft / slider.clientWidth));
          ticking = false;
        });
      }, { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goToSlide(Number(t.getAttribute('data-goto'))); });
      });
      slider.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var current = Math.round(slider.scrollLeft / slider.clientWidth);
        goToSlide(current + (e.key === 'ArrowRight' ? 1 : -1));
      });
    }

    function selectedOptions() {
      var opts = [];
      $$('[data-option-input]:checked', page).forEach(function (input) {
        opts[Number(input.getAttribute('data-option-position')) - 1] = input.value;
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }

    var addBtn = $('[data-add-to-cart]', page);
    var addText = $('[data-add-to-cart-text]', page);
    var buyNowBtn = $('[data-buy-now]', page);
    var stickyAdd = $('[data-sticky-add]');

    function updateUI(variant) {
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        if (buyNowBtn) buyNowBtn.disabled = true;
        if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.textContent = 'Unavailable'; }
        return;
      }
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var idInput = $('[data-variant-id-input]', page);
      if (idInput) idInput.value = variant.id;

      var priceEl = $('[data-price]', page);
      if (priceEl) { priceEl.textContent = formatMoney(variant.price); priceEl.classList.toggle('is-sale', !!onSale); }
      var compareEl = $('[data-compare-price]', page);
      if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price); }
      var savingEl = $('[data-saving-badge]', page);
      if (savingEl) {
        savingEl.hidden = !onSale;
        if (onSale) {
          var diff = variant.compare_at_price - variant.price;
          savingEl.textContent = 'Save ' + formatMoney(diff).replace(/\.00(?!\d)/, '') + ' (' + Math.floor(diff * 100 / variant.compare_at_price) + '%)';
        }
      }
      var stockEl = $('[data-stock-badge]', page);
      if (stockEl) {
        var lowStock = (window.Groomly && window.Groomly.lowStock) || 20;
        stockEl.classList.remove('in-stock', 'low-stock', 'out-of-stock');
        if (!variant.available) {
          stockEl.classList.add('out-of-stock'); stockEl.textContent = 'Out of stock';
        } else if (variant.inventory_managed && variant.inventory_quantity > 0 && variant.inventory_quantity <= lowStock) {
          stockEl.classList.add('low-stock'); stockEl.textContent = 'Only ' + variant.inventory_quantity + ' left — order soon';
        } else {
          stockEl.classList.add('in-stock'); stockEl.textContent = stockEl.getAttribute('data-in-stock-text') || 'In stock';
        }
      }
      var skuEl = $('[data-sku]', page);
      if (skuEl && variant.sku) skuEl.textContent = variant.sku;

      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (buyNowBtn) buyNowBtn.disabled = !variant.available;
      var stickyPrice = $('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stickyAdd) { stickyAdd.disabled = !variant.available; stickyAdd.textContent = variant.available ? 'Add to bag' : 'Sold out'; }

      if (variant.featured_media_id && slider) {
        var target = slider.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        if (target) goToSlide(Number(target.getAttribute('data-slide-index')));
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    page.addEventListener('change', function (e) {
      var input = e.target.closest('[data-option-input]');
      if (!input) return;
      var pos = input.getAttribute('data-option-position');
      $$('[data-option-input][data-option-position="' + pos + '"]', page).forEach(function (other) {
        var label = page.querySelector('label[for="' + other.id + '"]');
        if (label) label.classList.toggle('active', other.checked);
      });
      var valueEl = $('[data-option-value="' + pos + '"]', page);
      if (valueEl) valueEl.textContent = input.value;
      updateUI(findVariant(selectedOptions()));
    });

    page.addEventListener('click', function (e) {
      if (e.target.closest('[data-qty-minus]') && qtyInput) qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
      if (e.target.closest('[data-qty-plus]') && qtyInput) qtyInput.value = Number(qtyInput.value || 1) + 1;
    });

    function currentQty() { return qtyInput ? Math.max(1, Number(qtyInput.value || 1)) : 1; }
    function showError(msg) {
      var errEl = $('[data-cart-error]', page);
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = $('[data-variant-id-input]', page).value;
        showError('');
        if (addText) addText.textContent = 'Adding…';
        if (addBtn) addBtn.disabled = true;
        addToCart(id, currentQty())
          .then(function () {
            if (addText) addText.textContent = 'Added';
            setTimeout(function () { if (addText) addText.textContent = 'Add to bag'; if (addBtn) addBtn.disabled = false; }, 1400);
            refreshCartDrawer(true);
          })
          .catch(function (err) {
            if (addText) addText.textContent = 'Add to bag';
            if (addBtn) addBtn.disabled = false;
            showError(err.message);
          });
      });
    }
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
    // Coming back with the browser's Back button shows the page as it was left ("Taking you to checkout…",
    // "Adding…"): put the buttons back to normal.
    // (Only buttons still showing that state are touched: they were enabled when tapped.)
    window.addEventListener('pageshow', function () {
      if (buyNowBtn && buyNowBtn.textContent === 'Taking you to checkout…') { buyNowBtn.textContent = 'Buy it now'; buyNowBtn.disabled = false; }
      if (addText && /^(Adding…|Added)$/.test(addText.textContent)) { addText.textContent = 'Add to bag'; if (addBtn) addBtn.disabled = false; }
    });
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        var id = $('[data-variant-id-input]', page).value;
        showError('');
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = 'Taking you to checkout…';
        addToCart(id, currentQty())
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) {
            buyNowBtn.disabled = false;
            buyNowBtn.textContent = 'Buy it now';
            showError(err.message);
          });
      });
    }

    /* Sticky buy bar: only while the main button is off-screen */
    var sticky = $('[data-sticky-atb]');
    var mainCta = $('[data-main-cta]', page);
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', hidden);
        sticky.setAttribute('aria-hidden', hidden ? 'false' : 'true');
        if (stickyAdd) stickyAdd.tabIndex = hidden ? 0 : -1;
      }).observe(mainCta);
    }

    /* Long descriptions: clamp with "Read more" */
    var clamp = $('[data-clamp]', page);
    var clampBtn = $('[data-clamp-toggle]', page);
    if (clamp && clampBtn && clamp.scrollHeight > 320) {
      clamp.classList.add('is-clamped');
      clampBtn.hidden = false;
      clampBtn.addEventListener('click', function () {
        var open = clamp.classList.toggle('is-clamped');
        clampBtn.textContent = open ? 'Read more' : 'Show less';
      });
    }

    /* Delivery estimate as real dates, counting working days */
    var est = $('[data-delivery-estimate]', page);
    var estText = est && $('[data-delivery-text]', est);
    if (est && estText) {
      var skipFri = est.getAttribute('data-skip-friday') === 'true';
      var addDays = function (n) {
        var d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); if (!(skipFri && d.getDay() === 5)) n--; }
        return d;
      };
      var fmt = function (d) {
        try { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
        catch (e) { return d.toDateString(); }
      };
      var range = function (a, b) {
        var from = fmt(addDays(Number(a))), to = fmt(addDays(Number(b)));
        return from === to ? 'by ' + to : from + ' – ' + to;
      };
      estText.textContent = 'Inside Dhaka: ' + range(est.getAttribute('data-dhaka-min'), est.getAttribute('data-dhaka-max')) +
        ' · Outside Dhaka: ' + range(est.getAttribute('data-outside-min'), est.getAttribute('data-outside-max'));
    }

    /* Share: native share sheet on phones, WhatsApp fallback */
    var shareBtn = $('[data-share]', page);
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var title = shareBtn.getAttribute('data-share-title');
        var url = shareBtn.getAttribute('data-share-url');
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else {
          window.open('https://wa.me/?text=' + encodeURIComponent(title + ' ' + url), '_blank', 'noopener');
        }
      });
    }

    /* Remember for "Recently viewed" */
    try {
      var key = 'groomly:recent';
      var list = JSON.parse(localStorage.getItem(key) || '[]').filter(function (h) { return h !== data.handle; });
      list.unshift(data.handle);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }

  /* ── Recently viewed row ──────────────────────────── */
  function initRecentlyViewed() {
    var wrap = $('[data-recently-viewed]');
    if (!wrap) return;
    var grid = $('[data-recent-grid]', wrap);
    var exclude = wrap.getAttribute('data-exclude');
    var limit = Number(wrap.getAttribute('data-limit')) || 8;
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem('groomly:recent') || '[]'); } catch (e) {}
    handles = handles.filter(function (h) { return h && h !== exclude; }).slice(0, limit);
    if (!handles.length || !grid) return;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var items = products.filter(Boolean);
      if (!items.length) return;
      grid.innerHTML = items.map(function (p) { return cardHTML(p, true); }).join('');
      wrap.hidden = false;
      syncWishlistUI();
    });
  }

  /* ── Header: hide on scroll down, show on scroll up ── */
  function initHeader() {
    var header = $('.shopify-section-group-header-group .header-main');
    var wrap = header && header.parentElement;
    if (!wrap || !window.CSS || !CSS.supports('selector(:has(*))')) return;
    var lastY = window.scrollY;
    var root = document.documentElement;
    function setOffset(hidden) {
      root.style.setProperty('--header-offset', hidden ? '0px' : wrap.offsetHeight + 'px');
    }
    setOffset(false);
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var navOpen = document.querySelector('[data-mobile-nav].open') || document.querySelector('[data-search-panel].open');
      if (navOpen) { lastY = y; return; }
      if (Math.abs(y - lastY) < 6) return;
      var hide = y > lastY && y > wrap.offsetHeight + 40;
      wrap.classList.toggle('header-hidden', hide);
      setOffset(hide);
      lastY = y;
    }, { passive: true });
    window.addEventListener('resize', function () { setOffset(wrap.classList.contains('header-hidden')); });
    // Anything that needs the header (menu, search) brings it back first
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mobile-nav-open], [data-search-focus]')) {
        wrap.classList.remove('header-hidden');
        setOffset(false);
      }
      if (e.target.closest('[data-search-focus]')) {
        var input = $('[data-search-input]');
        if (input) { window.scrollTo({ top: 0, behavior: 'smooth' }); setTimeout(function () { input.focus(); }, 250); }
      }
    });
  }

  /* ── Tabs (desktop) / accordions (mobile) ─────────── */
  function initTabs() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tab]');
      if (btn) {
        var name = btn.getAttribute('data-tab');
        var root = btn.closest('[data-pdp-tabs]') || document;
        $$('[data-tab]', root).forEach(function (b) { b.classList.toggle('active', b === btn); });
        $$('[data-tab-panel]', root).forEach(function (p) {
          p.classList.toggle('active', p.getAttribute('data-tab-panel') === name);
        });
        return;
      }
      var acc = e.target.closest('[data-accordion]');
      if (acc) {
        var item = acc.closest('.tab-item');
        if (item) item.classList.toggle('open');
        return;
      }
      // Mobile drawer dropdowns (Shop by category / Brands)
      var dt = e.target.closest('[data-drawer-toggle]');
      if (dt) {
        var isOpen = dt.classList.toggle('open');
        dt.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        var sub = dt.nextElementSibling;
        if (sub && sub.classList.contains('mobile-nav-sub')) sub.classList.toggle('open', isOpen);
      }
    });
  }

  /* ── Horizontal scroll rows ───────────────────────── */
  function initScrollRows() {
    document.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-scroll-prev]');
      var next = e.target.closest('[data-scroll-next]');
      if (!prev && !next) return;
      var wrap = (prev || next).closest('[data-scroll-row]');
      var container = wrap && wrap.querySelector('[data-scroll-container]');
      if (container) container.scrollBy({ left: next ? 440 : -440, behavior: 'smooth' });
    });
  }

  /* ── Filters & sorting ────────────────────────────── */
  function initFilters() {
    // Auto-submit filter forms on change
    $$('form[data-filter-form]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return; // wait for explicit action on price inputs
        form.submit();
      });
      $$('input[type="number"]', form).forEach(function (input) {
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); form.submit(); }
        });
        input.addEventListener('blur', function () {
          if (input.value !== input.defaultValue) form.submit();
        });
      });
    });

    // Sort select — preserve existing params
    $$('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ── Recommendations ──────────────────────────────── */
  function initRecommendations() {
    var el = $('[data-recommendations]');
    if (!el || !el.getAttribute('data-url')) return;
    fetch(el.getAttribute('data-url'))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = temp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
          syncWishlistUI();
        }
      })
      .catch(function () {});
  }

  /* ── Predictive search ────────────────────────────── */
  function initPredictiveSearch() {
    var input = $('[data-search-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results) return;
    var panel = $('[data-search-panel]');
    if (panel) {
      input.addEventListener('focus', function () { panel.classList.add('open'); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') panel.classList.remove('open');
      });
    }
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var base = (window.Groomly && window.Groomly.routes && window.Groomly.routes.predictiveSearch) || '/search/suggest';
        fetch(base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            results.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '&width=80" alt="">' : '';
              return '<a class="predictive-item" href="' + p.url + '">' + img +
                '<div><div class="predictive-item-title">' + p.title + '</div>' +
                '<div class="predictive-item-price">' + p.price + '</div></div></a>';
            }).join('');
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ── Order note (cart drawer + cart page) ─────────── */
  // Autosave so the note survives drawer re-renders and reaches checkout → order Notes.
  function initCartNote() {
    var timer;
    function save(el) {
      clearTimeout(timer);
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: el.value })
      }).catch(function () {});
    }
    document.addEventListener('input', function (e) {
      var el = e.target.closest('[data-cart-note]');
      if (!el) return;
      clearTimeout(timer);
      timer = setTimeout(function () { save(el); }, 500);
    });
    document.addEventListener('change', function (e) {
      var el = e.target.closest('[data-cart-note]');
      if (el) save(el);
    });
  }

  /* ── Global click handling ────────────────────────── */
  function initGlobalClicks() {
    document.addEventListener('click', function (e) {
      // Cart open/close
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

      // Cart line changes
      var lineBtn = e.target.closest('[data-line-change]');
      if (lineBtn) {
        e.preventDefault();
        // Show the new quantity at once; the drawer then refreshes with the real cart.
        var key = lineBtn.getAttribute('data-key'), variant = lineBtn.getAttribute('data-variant'), step = lineBtn.getAttribute('data-step');
        var item = lineBtn.closest('.cart-item'), num = item && item.querySelector('.qty-num');
        if (key && variant) {
          var target = step !== null && num ? Math.max(0, Number(num.textContent) + Number(step)) : Number(lineBtn.getAttribute('data-qty'));
          if (num) num.textContent = String(target);
          if (target === 0 && item) item.classList.add('is-removing');
          queueLine(variant, key, target);
          return;
        }
        changeLine(lineBtn.getAttribute('data-line'), lineBtn.getAttribute('data-qty'), lineBtn.hasAttribute('data-reload'));
        return;
      }

      // Quick add
      var quickBtn = e.target.closest('[data-quick-add]');
      if (quickBtn) {
        e.preventDefault();
        e.stopPropagation();
        var labelEl = quickBtn.querySelector('[data-quick-label]') || quickBtn;
        var original = labelEl.textContent;
        labelEl.textContent = 'Adding…';
        addToCart(quickBtn.getAttribute('data-variant-id'), 1)
          .then(function () {
            labelEl.textContent = 'Added';
            quickBtn.classList.add('is-added');
            setTimeout(function () { labelEl.textContent = original; quickBtn.classList.remove('is-added'); }, 1600);
            refreshCartDrawer(true);
          })
          .catch(function () {
            labelEl.textContent = 'Try again';
            setTimeout(function () { labelEl.textContent = original; }, 2000);
          });
        return;
      }

      // Wishlist toggle
      var wishBtn = e.target.closest('[data-wishlist-toggle]');
      if (wishBtn) {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlist(wishBtn.getAttribute('data-handle'));
        if ($('[data-wishlist-grid]')) renderWishlistPage();
        return;
      }

      // Mobile nav
      if (e.target.closest('[data-mobile-nav-open]')) {
        var nav = $('[data-mobile-nav]');
        if (nav) nav.classList.add('open');
        return;
      }
      if (e.target.closest('[data-mobile-nav-close]')) {
        var nav2 = $('[data-mobile-nav]');
        if (nav2) nav2.classList.remove('open');
        return;
      }

      // Header search panel: close when clicking outside the search form
      if (!e.target.closest('[data-header-search]')) {
        var panel = $('[data-search-panel]');
        if (panel) panel.classList.remove('open');
      }

      // Filter drawer (mobile)
      if (e.target.closest('[data-filter-open]')) {
        var panel = $('[data-filter-panel]');
        if (panel) panel.classList.add('open');
        return;
      }
      if (e.target.closest('[data-filter-close]')) {
        var panel2 = $('[data-filter-panel]');
        if (panel2) panel2.classList.remove('open');
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeCart();
        var overlay = $('[data-search-overlay]');
        if (overlay) overlay.classList.remove('open');
        var nav = $('[data-mobile-nav]');
        if (nav) nav.classList.remove('open');
        var panel = $('[data-filter-panel]');
        if (panel) panel.classList.remove('open');
      }
    });
  }

  /* ── Slideshow ────────────────────────────────────── */
  function initSlideshow() {
    $$('[data-slideshow]').forEach(function (show) {
      var slides = $$('[data-slide]', show);
      if (slides.length < 2) return;
      var dots = $$('[data-slide-dot]', show);
      var current = 0;
      var timer = null;

      function goTo(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('active', i === current); });
        dots.forEach(function (d, i) { d.classList.toggle('active', i === current); });
      }
      function startAutoplay() {
        if (show.getAttribute('data-autoplay') !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var interval = Number(show.getAttribute('data-interval')) || 5000;
        timer = setInterval(function () { goTo(current + 1); }, interval);
      }
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          clearInterval(timer);
          goTo(Number(d.getAttribute('data-slide-dot')));
          startAutoplay();
        });
      });

      // Arrows
      $$('[data-slide-prev], [data-slide-next]', show).forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          clearInterval(timer);
          goTo(current + (arrow.hasAttribute('data-slide-next') ? 1 : -1));
          startAutoplay();
        });
      });

      // Swipe on touch devices
      var startX = null;
      show.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      show.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) {
          clearInterval(timer);
          goTo(current + (dx < 0 ? 1 : -1));
          startAutoplay();
        }
        startX = null;
      }, { passive: true });

      startAutoplay();
    });
  }

  /* ── Newsletter popup ─────────────────────────────── */
  function initPopup() {
    var popup = $('[data-popup]');
    if (!popup) return;
    var key = popup.getAttribute('data-popup-key') || 'groomly-popup';
    // Keep showing after a successful subscribe? No — also mark seen on success message.
    try {
      if (localStorage.getItem(key)) return;
    } catch (e) { return; }
    var delay = Number(popup.getAttribute('data-popup-delay')) || 6000;
    setTimeout(function () { popup.hidden = false; }, delay);

    function dismiss() {
      popup.hidden = true;
      try { localStorage.setItem(key, '1'); } catch (e) {}
    }
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]') || e.target === popup) dismiss();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) dismiss();
    });
    var form = popup.querySelector('form');
    if (form) form.addEventListener('submit', function () {
      try { localStorage.setItem(key, '1'); } catch (e) {}
    });
  }

  /* ── Video cards ──────────────────────────────────── */
  function initVideoCards() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-video-toggle]');
      if (!btn) return;
      var card = btn.closest('.video-card');
      var video = card && card.querySelector('video');
      if (!video) return;
      if (video.paused) {
        // pause any other playing card first
        $$('.video-card.playing video').forEach(function (v) { v.pause(); v.closest('.video-card').classList.remove('playing'); });
        video.play();
        card.classList.add('playing');
      } else {
        video.pause();
        card.classList.remove('playing');
      }
    });
  }

  /* ── Brand strip: randomize order per page load ───── */
  function initBrandShuffle() {
    var strip = $('[data-shuffle-brands]');
    if (!strip) return;
    var tracks = $$('.brand-strip-track', strip);
    if (!tracks.length) return;
    var count = tracks[0].children.length;
    // Fisher–Yates permutation, applied identically to every track
    var order = [];
    for (var i = 0; i < count; i++) order.push(i);
    for (var j = count - 1; j > 0; j--) {
      var k = Math.floor(Math.random() * (j + 1));
      var tmp = order[j]; order[j] = order[k]; order[k] = tmp;
    }
    tracks.forEach(function (track) {
      var items = Array.prototype.slice.call(track.children);
      order.forEach(function (idx) { track.appendChild(items[idx]); });
    });
  }

  /* ── Boot ─────────────────────────────────────────── */
  /* ── Desktop menu bar: keyboard + touch support for dropdowns ── */
  // Hover opens panels via CSS; this keeps aria-expanded honest, opens panels
  // for keyboard focus, lets Escape close them, and makes a first tap on a
  // touch screen open the panel instead of following the link.
  function initMegaMenu() {
    var items = $$('[data-nav-item]');
    if (!items.length) return;
    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var trigger = item.querySelector('.nav-link');
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    items.forEach(function (item) {
      var trigger = item.querySelector('.nav-link');
      item.addEventListener('mouseenter', function () { item.classList.remove('is-dismissed'); setOpen(item, true); });
      item.addEventListener('mouseleave', function () { item.classList.remove('is-dismissed'); setOpen(item, false); });
      item.addEventListener('focusin', function () { item.classList.remove('is-dismissed'); setOpen(item, true); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) setOpen(item, false);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        setOpen(item, false);
        item.classList.add('is-dismissed');
        if (trigger) trigger.focus();
      });
      if (trigger) trigger.addEventListener('touchend', function (e) {
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          items.forEach(function (other) { if (other !== item) setOpen(other, false); });
          setOpen(item, true);
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nav-item]')) return;
      items.forEach(function (item) { setOpen(item, false); });
    });
  }

  /* ── Origin product tabs (ARIA tabs pattern) ──────── */
  function initOriginTabs() {
    $$('[data-origin-tabs]').forEach(function (root) {
      var tabs = $$('[role="tab"]', root);
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panelId = t.getAttribute('aria-controls');
          var panel = document.getElementById(panelId);
          if (panel) panel.hidden = !on;
          var viewAll = root.querySelector('[data-origin-viewall="' + panelId.replace('OriginPanel-', '') + '"]');
          if (viewAll) viewAll.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') next = tabs[0];
          if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMegaMenu();
    initHeader();
    initRecentlyViewed();
    initOriginTabs();
    initBrandShuffle();
    initGlobalClicks();
    initCartNote();
    initProductPage();
    initTabs();
    initScrollRows();
    initFilters();
    initRecommendations();
    initPredictiveSearch();
    initSlideshow();
    initPopup();
    initVideoCards();
    syncWishlistUI();
    renderWishlistPage();
  });
})();
